import { CommonStylesDefaultValues } from 'cms/cms-shared/common-settings-styles/common-settings-styles.models';
import { IdtComponentCmsDefinition, CmsComponentGroups } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';


export const PieceMenuDefinition: IdtComponentDefinition = {
  id: 'piece-menu',
  role: IdtComponentRole.Piece,
  numSlots: 0
};

export const PieceMenuCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Menu',
  group: CmsComponentGroups.Components,
  availablePlatforms: ['web'],
  isDeprecated: true,
  initialSettings: () => {
    return {
      storeId: null,
      catalogType: null,
      general: {
        overrideRootCategory: false,
        overrideRootCategoryId: null,
        categoryArtwork: null
      },
      styles: {
        ...CommonStylesDefaultValues
      }
    };
  }
};
